import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';

import type {ReportKey} from '../../report-types';

import styles from './chart-error-state.module.css';

type Props = {
    isTimedOut?: boolean;
    isErrored?: boolean;
    reportKey: ReportKey;
};

export function ChartErrorState(props: Props) {
    if (props.isErrored) {
        return props.reportKey === 'siteAnalytics' ? (
            <div className={styles['chart-error-state']}>
                <EmptyStateSmall
                    title='We couldn’t load this report'
                    subtitle='This report is updated nightly… check back tomorrow!'
                    icon={
                        <div style={{width: '150px'}}>
                            <Illustration src='plug-error-state' width='100%' height='100%' />
                        </div>
                    }
                />
            </div>
        ) : (
            <div className={styles['chart-error-state']}>
                <h2 className={styles.title}>Oh no, something went wrong</h2>
                <p className={styles.subtitle}>
                    Please try again later.
                    <br />
                    If this error persists, please{' '}
                    <Link variant='primary' newTab={true} href='https://support.nutshell.com/'>
                        contact support
                    </Link>
                    .
                </p>
            </div>
        );
    }
    if (props.isTimedOut) {
        return (
            <div className={styles['chart-error-state']}>
                <h2 className={styles.title}>The server took too long to respond</h2>
                <p className={styles.subtitle}>
                    We may have had trouble processing too much data. While we work on speeding
                    things up,
                    <br />
                    you can try narrowing down the date range, or grouping by months, quarters, or
                    years.
                </p>
            </div>
        );
    }

    return null;
}
